"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ScaleLightness_1 = __importDefault(require("./ScaleLightness"));
/** @description makes a color a certain percentage lighter than it was before, functioning like the lightness parameter of scss scale (https://sass-lang.com/documentation/modules/color#scale)
 * To adjust lightness by a fixed amount, use lighten and darken instead.
 *
 * @param {string} color Six digit hex code beginning with #. Examples: #ff0000, #FFFFFF, #b37399.
 * @param {number} colorLevel value ranging from 0 to 1000 (as in --primary-500, --primary-140, --primary-740).
 *       500 is equivalent to the base color.
 *       005 is the color scaled almost to white.
 *       995 is the color scaled almost to black.
 *
 * @return {string} Six digit hex code beginning with #. Examples: #ff0000, #FFFFFF, #b37399.
 */
function scaleLightnessToColorLevel(color, colorLevel) {
    if (colorLevel < 0)
        colorLevel = 0;
    if (colorLevel > 1000)
        colorLevel = 1000;
    let scaleLightnessAmount = (colorLevel - 500) / 5;
    return (0, ScaleLightness_1.default)(color, scaleLightnessAmount);
}
exports.default = scaleLightnessToColorLevel;
//# sourceMappingURL=ScaleLightnessToColorLevel.js.map